type Props = {
  size: number;
  strokeColor?: string;
};

const Restaurant = ({ size, strokeColor }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 1.5C11.6642 1.5 12 1.83579 12 2.25V9.54004C11.9999 9.54997 11.9995 9.56331 11.999 9.5791C11.998 9.61094 11.9957 9.65466 11.9922 9.70801C11.9851 9.81483 11.9715 9.96287 11.9443 10.1387C11.8904 10.4869 11.7815 10.9637 11.5557 11.4502C11.329 11.9384 10.9744 12.4578 10.4219 12.8545C10.0283 13.1371 9.55575 13.3381 9 13.4346V21.75C9 22.1642 8.66421 22.5 8.25 22.5C7.83579 22.5 7.5 22.1642 7.5 21.75V13.4346C6.94425 13.3381 6.47175 13.1371 6.07812 12.8545C5.52558 12.4578 5.171 11.9384 4.94434 11.4502C4.71852 10.9637 4.60955 10.4869 4.55566 10.1387C4.52846 9.96287 4.51491 9.81483 4.50781 9.70801C4.50427 9.65466 4.50197 9.61094 4.50098 9.5791C4.50049 9.56331 4.50015 9.54997 4.5 9.54004V2.25C4.5 1.83579 4.83579 1.5 5.25 1.5C5.66421 1.5 6 1.83579 6 2.25V9.53223C6.00048 9.54767 6.0016 9.57363 6.00391 9.6084C6.00854 9.67819 6.01847 9.78238 6.03809 9.90918C6.07792 10.1666 6.15665 10.4973 6.30566 10.8184C6.45399 11.1378 6.66196 11.4267 6.95312 11.6357C7.09924 11.7406 7.2781 11.8335 7.5 11.8994V2.25C7.5 1.83579 7.83579 1.5 8.25 1.5C8.66421 1.5 9 1.83579 9 2.25V11.8994C9.2219 11.8335 9.40076 11.7406 9.54688 11.6357C9.83804 11.4267 10.046 11.1378 10.1943 10.8184C10.3434 10.4973 10.4221 10.1666 10.4619 9.90918C10.4815 9.78238 10.4915 9.67819 10.4961 9.6084C10.4984 9.57363 10.4995 9.54767 10.5 9.53223V2.25C10.5 1.83579 10.8358 1.5 11.25 1.5ZM19.5 21.75C19.5 22.1642 19.1642 22.5 18.75 22.5C18.3358 22.5 18 22.1642 18 21.75V13.5H15C15 5.25 19.5 1.5 19.5 1.5V21.75Z"
        fill={strokeColor || '#868686'}
      />
    </svg>
  );
};

export default Restaurant;
